import { InternalLink } from '@/atoms/InternalLink'
import { paths } from '@/constants/paths'
import { BlogPost, extractCloudinaryImage } from '@/services/BlogService'
import { ProjectDetails } from '@/services/ProjectsService'
import { getCloudinaryImageUrl } from '@/utils/Cloudinary'

interface RecentPostsProps {
  posts: BlogPost[]
  project: ProjectDetails
}

export const RecentPosts: React.FC<RecentPostsProps> = ({ posts, project }) => (
  <>
    {posts.length > 0 && (
      <section role="complementary" id="recent-posts">
        <div className="border-b-[1px] pb-4 text-2xl">Recent Posts</div>
        {posts.map((recent) => (
          <InternalLink key={recent?.title} href={`${paths.blog.index}/${project.slug}/posts/${recent?.slug}`}>
            <div className="grid cursor-pointer grid-cols-3 gap-4 pt-6">
              <img
                alt={recent?.header}
                className="col-span-1 min-h-[77px] object-cover"
                src={getCloudinaryImageUrl({
                  height: 77,
                  path: `v${extractCloudinaryImage(recent)?.version}/${extractCloudinaryImage(recent)?.public_id}.webp`,
                  transforms: 'ar_2.65,c_fill,g_faces',
                })}
              />
              <div className="col-span-2 text-xl font-semibold">{recent?.title}</div>
            </div>
          </InternalLink>
        ))}
      </section>
    )}
  </>
)
